module.exports = __webpack_public_path__ + "img/hair_front_male_hairline.93ea1fd9.png";